import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import SettingsFilter from 'components/common/SettingsFilter';

import styled from 'styled-components';
import { SCREEN_WIDTHS } from '@twicapp/ui/constants/breakpoints';
import ProfileContext from 'contexts/ProfileContext';
import PretaxContext from 'contexts/PretaxContext';

const Container = styled.div`
  display: flex;
  max-width: 880px;
  margin: 0 auto;
  padding: 22px 16px 0 16px;
  flex-direction: column;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_LANDSCAPE}) {
    flex-direction: row;
    gap: 99px;
    padding: 80px 0 0;
  }
`;

const Main = styled.div`
  flex: 1;
`;

const SettingsLayout = ({ children }: $TSFixMe) => {
  const { company, employee } = useContext(ProfileContext);
  const { pretax_accounts, pretax_dependents } = useContext(PretaxContext);
  const location = useLocation();
  const active_path = location.pathname;

  return (
    <Container>
      <SettingsFilter
        active_path={active_path}
        company={company}
        employee={employee}
        dependents={pretax_dependents}
        pretax_accounts={pretax_accounts}
      />
      <Main>{children}</Main>
    </Container>
  );
};

export default SettingsLayout;
